



<!--label for="exampleSelect1">Medlem</label>
<select class="form-control form-control-sm cap" id="land">
  <input type="text" class="form-control" #search placeholder="search" style="width:300px;" [(ngModel)]="searchTerm" />
  <option *ngFor="let user of users | userfilter:searchTerm" [value]="user.firstName" (click)="setSearchTerm(user.firstName)">{{user.firstName}} {{user.lastName}}</option>

</select-->

<table>
<tr *ngFor="let user of users | userfilter:searchTerm" (click)="setSearchTerm(user.firstName)">
<td>{{user.firstName}}</td>
<td>{{user.lastName}}</td>
<td>{{user.Postnr}}</td>
</tr>
</table>




